<template>
  <div class="spaceCenter">
    <div class="exchange-card" v-loading="loading || isNetworkLoading">
      <div class="exchange-tab-box spaceCenter">
        <!-- <i class="iconfont trn-daikuan"></i> -->
        <img src="@/assets/image/loan/title-icon.svg" alt="" style="width: .35rem">
        <span>Borrow TCash</span>
      </div>


      <div class="exchange-tab-body">
        <div style="margin-bottom: 0.2rem;">
          <span class="word-sm">Credit Check:</span>
          <span :class="{
            'credit-check-pending': !account,
            'credit-check-passed': account && creditCheckStatus,
            'credit-check-failed': account && !creditCheckStatus
          }">
            {{ account ? (creditCheckMessage) : 'Pending (must mint REP at least twice)' }}
          </span>
          <span class="credit-check-passed" style="color: #929DAD;" v-if="account">{{
            creditCheckStatus ? '(2 REP mints completed)' : '(At least 2 REP mints required)'
          }}</span>
        </div>
        <!-- <div class="spaceBetween">
          <span class="word-sm"><img src="@/assets/image/exchange/jiantou.svg" style="width:0.16rem;" />1 UNIT = $ {{
            unitPrice }}</span>
          <span class="word-sm" style="color: rgb(220, 224, 231);">Balance : <big-number
              :number.sync="balance" /></span>
        </div> -->
        <div style="color: #DCE0E7;font-size: 0.18rem;line-height: 0.23rem;margin: 0.15rem 0;">Collateral:</div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft">
            <img src="@/assets/image/exchange/unit.png" style="width:0.44rem;margin-right:0.16rem;" />
            <div>
              <div class="word-sm-black">UNIT</div>
              <span class="word-sm" style="color:rgb(86, 98, 122)">Price: ${{ unitPrice }}</span>
            </div>
          </div>
          <div>
            <el-input class="exchange-input" placeholder="0.00" v-model="exchangeNumUnit" @input="exchangeInputUnit()"
              @blur="exchangeInputUnit()" />
            <div style="color: #38F4BA;" class="text-right word-sm-num">
              Balance : {{ account ? smallNum(balance) : '0.00' }}
            </div>
          </div>
        </div>
        <!-- <div class="spaceBetween" style="margin:-.09rem 0 .2rem 0;padding: 0 .13rem">
          <span class="word-sm">Pledge rate : {{ pledgeRate }} %</span>
          <span class="word-sm">Daily interest rate : {{ dailyInterestRate }} %</span>
        </div>
         -->
        <div style="color: #DCE0E7;font-size: 0.18rem;line-height: 0.23rem;margin: 0.15rem 0;">Borrow:</div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft">
            <img src="@/assets/image/exchange/TCashIcon.png" style="width:0.44rem;margin-right:0.16rem;" />
            <div>
              <div class="word-sm-black">TCash</div>
              <span class="word-sm" style="color:rgb(86, 98, 122)">Price: ${{ TCASHPrice }}</span>
            </div>
          </div>
          <div>
            <el-input class="exchange-input" placeholder="0.00" v-model="exchangeNumUSTN" @input="exchangeInputUSTN()"
              @blur="exchangeInputUSTN()" />

            <div style="color: #38F4BA;" class="text-right word-sm-num">Borrowable :
              <span v-if="account">
                <big-number :number.sync="maximum" :count="2" />
              </span>
              <span v-else>
                0.00
              </span>
            </div>
          </div>
        </div>
        <div class="spaceBetween risk-interest-info" style="margin-bottom:0.3rem;" v-if="account">
          <span style="color: #929DAD; font-size: 0.18rem;">
            Risk Factors: {{ riskFactor }} %
            <el-tooltip effect="dark" placement="top"
              content="Your risk factor, based on personal credit and system conditions, determines how much TCash you can borrow.">
              <i class="el-icon-question"
                style="color: #929DAD; margin-left: 0.05rem; cursor: pointer; font-size: 0.16rem;"></i>
            </el-tooltip>
          </span>
          <span style="color: #929DAD; font-size: 0.18rem;">
            Interest Rate: {{ dailyInterestRate }}%
            <el-tooltip effect="dark" placement="top"
              content="Note: This is a daily interest rate. Borrowed TCash accrue interest daily.">
              <i class="el-icon-question"
                style="color: #929DAD; margin-left: 0.05rem; cursor: pointer; font-size: 0.16rem;"></i>
            </el-tooltip>
          </span>
        </div>
        <checkLoginBtn label="Borrow TCash" :needConnect="true" @clickHandle="submit"
          @walletConnected="walletConnected" />

        <!-- <div>How to Borrow?</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import {
  toBigNum,
  toBigItem,
  toSmallNum,
  fixed
} from "@/utils/bigNumberTran.js";
import { isIntNum } from "@/utils/index.js"
import BigNumber from "bignumber.js";
// import request from "@/utils/request";
import { getAbi } from "@/api/contract.js";
import Web3 from "web3";
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";
export default {
  components: { checkLoginBtn },
  data() {
    return {
      loading: false,
      isNetworkLoading: false,
      activeName: "lending",
      balance: 0,
      unitPrice: 0,
      TCASHPrice: 0,
      exchangeNumUnit: undefined,
      exchangeNumUSTN: undefined,
      maximum: 0,
      pledgeRate: 0,
      dailyInterestRate: 0,
      creditCheckStatus: false,
      creditCheckMessage: '',
      personalCreditLimit: 0,
      availableLoanBalance: 0,
      riskFactor: 0,
      debounceTimer: null,
      maxUnitAmount: 0, // Maximum UNIT amount corresponding to maximum loan limit
      minUnitAmount: 0, // Minimum UNIT amount corresponding to minimum loan limit (0.000000001 TCash)
      GAS_MULTIPLIER: 1.2, // Gas estimation multiplier, adding extra gas to prevent insufficient gas
      web3: null, // Unified web3 instance
      aList: [
        {
          type: "Treasurenet",
          name: process.env.VUE_APP_TN_CHAIN_NAME.toLowerCase(),
          id: process.env.VUE_APP_TN_CHAINID.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_TN_RPC_URLS),
          nativeCurrency: {
            name: "UNIT",
            symbol: "UNIT",
            decimals: 18
          }
        },
        {
          type: "Ethereum",
          name: process.env.VUE_APP_ETH_NAME.toLowerCase(),
          id: process.env.VUE_APP_ETH_CHAINID.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_ETH_RPC_URLS),
          nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
          }
        }
      ],
    };
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    },
    changeMoney() {
      return (this.unitPrice * (+this.exchangeNumUnit || 0)).toFixed(2);
    }
  },
  methods: {
    // Debounce function
    debounce(fn, delay = 500) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        fn();
      }, delay);
    },
    smallNum(num) {
      let res = toSmallNum(num);
      return res.toFixed(2);
    },
    async init() {
      try {
        this.loading = true;

        // 检查当前网络是否是Treasurenet
        const chainId = await window.ethereum.request({ method: "eth_chainId" });
        const decimalChainId = parseInt(chainId, 16);

        // 找到Treasurenet网络配置
        const treasurenetNetwork = this.aList.find(item => item.type === "Treasurenet");
        // 如果当前不是Treasurenet网络，则切换
        if (treasurenetNetwork && treasurenetNetwork.id != decimalChainId) {
          this.isNetworkLoading = true;
          this.$message.info("Switching to Treasurenet network...");

          try {
            const treasurenetChainId = '0x' + Number(treasurenetNetwork.id).toString(16);
            try {
              // 尝试切换到Treasurenet网络
              await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: treasurenetChainId }]
              });
            } catch (switchError) {
              // 如果网络不存在，尝试添加
              if (switchError.code === 4902) {
                let params = [{
                  chainId: treasurenetChainId,
                  chainName: treasurenetNetwork.name,
                  rpcUrls: Array.isArray(treasurenetNetwork.rpcUrls) ? treasurenetNetwork.rpcUrls : [treasurenetNetwork.rpcUrls],
                  nativeCurrency: treasurenetNetwork.nativeCurrency
                }];

                await window.ethereum.request({
                  method: "wallet_addEthereumChain",
                  params: params
                });

                // 重试切换
                await window.ethereum.request({
                  method: "wallet_switchEthereumChain",
                  params: [{ chainId: treasurenetChainId }]
                });
              } else {
                throw switchError;
              }
            }

            // 更新账户状态
            await this.onClickConnect();

          } catch (error) {
            console.error("Network switch failed:", error);
            this.$message.error("Failed to switch to Treasurenet network");
            this.loading = false;
            this.isNetworkLoading = false;
            return;
          } finally {
            this.isNetworkLoading = false;
          }
        }

        // Initialize web3 instance
        this.web3 = new Web3(window.ethereum);

        // Get contract ABI and address
        const contracts = ['contractTAT', 'contractTCashLoan', 'contractOracle', 'contractTCash', 'contractParameterInfo', 'contractTCashAuction'];
        const contractsName = ['TAT', 'TCashLoan', 'Oracle', 'TCash', 'ParameterInfo', 'TCashAuction'];

        for (let i = 0; i < contracts.length; i++) {
          // const res = await getAbi(contractName);
          // if (res.code !== 0) throw new Error(`Failed to get ${contractName} ABI`);
          // // Correctly save ABI and address
          let res = this.$store.getters.contractMap[contracts[i]];
          console.log('res', res);
          this[contractsName[i]] = res.contract;
          // this[`${contractsName[i]}ABI`] = res.contract;
          this[`${contractsName[i]}Address`] = res.address;
          // Initialize contract instances using the unified web3 instance
          // this[contractsName[i]] = new this.web3.eth.Contract(this[`${contractsName[i]}ABI`], this[`${contractsName[i]}Address`]);
          // this[contractsName[i]] = new this.web3.eth.Contract(this[`${contractsName[i]}ABI`], this[`${contractsName[i]}Address`]);
        }
        await this.getInfo();
        console.log('this.TCashAuction', this.TCashAuction);
        let queryBidDurationres = await this.TCashAuction.methods.queryBidDuration().call();
        console.log('queryBidDurationres', queryBidDurationres);
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    },
    // 添加连接MetaMask的方法
    async onClickConnect() {
      try {
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
        } else {
          this.account = accounts[0];
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: accounts[0]
          });
          setToken(this.account);
        }
      } catch (error) {
        console.error("Failed to connect MetaMask:", error);
        this.$store.commit("app/SET_MATEMASK", { isConnect: false });
      }
    },
    async getInfo() {
      // Check if MetaMask is connected
      if (!this.account) {
        try {
          // Try to connect MetaMask
          await ethereum.request({ method: "eth_requestAccounts" });
          const accounts = await ethereum.request({ method: "eth_accounts" });
          console.log('accounts', accounts);
          if (accounts[0]) {
            // this.account = accounts[0];
            this.$store.commit("app/SET_MATEMASK", {
              isConnect: true,
              account: accounts[0]
            });
            // Set token after successful connection
            setToken(this.account);
          } else {
            this.$message.warning("Please connect MetaMask wallet first");
            return;
          }
        } catch (error) {
          console.error("Failed to connect MetaMask:", error);
          this.$message.error("Failed to connect MetaMask, please connect manually");
          return;
        }
      }

      let PRFres = await this.TCashLoan.methods.getPRF(this.account).call({
        from: this.account
      })
      console.log('PRFres', PRFres);

      // Use call method to get contract data, not send method
      let SRFres = await this.TCashLoan.methods.getSRF().call({
        from: this.account
      });
      console.log('SRFres', SRFres);


      await this.getBalance();
      await this.getUnitPrice();
      await this.getTCashPrice();
      await this.getRiskFactor();
      // this.getUnitPrice('UNIT', this.UNITVal);
      // this.getUnitPrice('USTN', this.USTNVal);
      // this.getPledgeRate();
      await this.getUSTNLoanInterestRate();
      if (this.account) {
        await this.checkCreditEligibility();
      }
      // this.loanPossible();
      this.exchangeNumUnit = undefined;
      this.exchangeNumUSTN = undefined;
    },
    async getRiskFactor() {
      try {
        if (this.TCashLoan && this.account) {
          const crfResult = await this.TCashLoan.methods["getCRF"](this.account).call({
            from: this.account
          });
          console.log('Risk Factor CRF:', crfResult);
          this.riskFactor = crfResult / 100; // Assuming the return value needs to be divided by 100 to convert to percentage
        }
      } catch (error) {
        console.error('Failed to get risk factor:', error);
      }
    },
    async getBalance() {
      try {
        if (!this.account) {
          return;
        }
        this.balance = await this.web3.eth.getBalance(this.account);
        // this.tcashBalance = await this.TCash.methods.balanceOf(this.account).call({  
        //   from: this.account
        // });
        // console.log('this.balanceTCash', this.tcashBalance);
      } catch (e) {
        console.log(e);
      }
    },
    async getUnitPrice() {
      try {
        let Oracleres = await this.Oracle.methods.getPriceData("UNIT").call({
          from: this.account
        });
        this.unitPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    async getTCashPrice() {
      try {
        let Oracleres = await this.Oracle.methods.getPriceData("TCASH").call({
          from: this.account
        });
        this.TCASHPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    async getPledgeRate() {
      try {
        let res = await this.ParameterInfo.methods[
          "getUSTNLoanPledgeRate"
        ]().call({
          from: this.account
        });
        this.pledgeRate = res / 100;
      } catch (e) {
        console.log(e);
      }
    },
    async getUSTNLoanInterestRate() {
      try {
        console.log('getUSTNLoanInterestRate', this.ParameterInfo);
        let res = await this.ParameterInfo.methods[
          "getUSTNLoanInterestRate"
        ]().call({
          from: this.account
        });
        console.log('getUSTNLoanInterestRate', res);
        this.dailyInterestRate = res / 100;
      } catch (e) {
        console.log('getUSTNLoanInterestRate error', e);
      }
    },
    async loanPossible() {
      try {
        if (!this.account || !this.TCashLoan) {
          this.maximum = 0;
          return;
        }

        this.maximum = await this.TCashLoan.methods[
          "loanPossible"
        ]().call({
          from: this.account
        });
      } catch (e) {
        console.log(e);
        this.maximum = 0;
      }
    },
    async getLoansRate() {
      try {
        this.loading = true;
        if (!this.TCashLoan || !this.account) {
          this.loading = false;
          return;
        }
        if (!this.exchangeNumUnit) {
          this.loading = false;
          return;
        }
        // console.log('toBigNum(this.exchangeNumUnit)', toBigNum(this.exchangeNumUnit))
        // Call getCRF contract function to get risk factor

        await this.getRiskFactor();

        let res = await this.TCashLoan.methods["calculateLoanAmount"](
          this.account,
          toBigNum(this.exchangeNumUnit)
        ).call({
          from: this.account
        });
        // console.log('getLoansRate', res);

        const smallNum = toSmallNum(res);
        // 避免科学计数法显示问题，使用 BigNumber 的 toFixed 方法
        this.exchangeNumUSTN = new BigNumber(smallNum).toFixed(9).replace(/\.?0+$/, '');
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async getUnitsRequired() {
      try {
        this.loading = true;
        if (!this.TCashLoan || !this.account) {
          this.loading = false;
          return;
        }
        if (!this.exchangeNumUSTN) {
          this.loading = false;
          return;
        }
        let res = await this.TCashLoan.methods["calculateUnitRequirement"](
          toBigNum(this.exchangeNumUSTN)
        ).call({
          from: this.account
        });
        const smallNum = toSmallNum(res);
        // 避免科学计数法显示问题，使用 BigNumber 的 toFixed 方法
        this.exchangeNumUnit = new BigNumber(smallNum).toFixed(9).replace(/\.?0+$/, '');
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async checkCreditEligibility() {
      try {
        if (!this.account) {
          this.creditCheckStatus = false;
          this.creditCheckMessage = 'Please connect wallet first';
          return;
        }

        console.log('checkCreditEligibility', this.TCashLoan, this.account);

        if (!this.TCashLoan) {
          this.creditCheckStatus = false;
          this.creditCheckMessage = 'Contract instance not initialized';
          return;
        }
        const tatResult = await this.TAT.methods.getTATRecord(this.account).call();
        console.log('tatResult', tatResult);
        if (tatResult.amounts.length < 2) {
          this.creditCheckStatus = false;
          this.creditCheckMessage = 'Not Passed';
          return;
        }
        this.creditCheckStatus = true;
        this.creditCheckMessage = 'Passed';
      } catch (e) {
        console.error('Credit check failed:', e);
        this.creditCheckStatus = false;
        this.creditCheckMessage = 'Credit check failed, please try again later';
      }
      await this.getPersonalCreditAndAvailable();
    },
    async getPersonalCreditAndAvailable() {
      if (!this.creditCheckStatus) {
        return;
      }
      // Get personal credit limit and available loan balance
      const result = await this.TCashLoan.methods.getPersonalCreditAndAvailable(this.account).call();
      console.log('getPersonalCreditAndAvailableresult', result);
      // Destructure returned values
      const PCL = result[0]; // Personal Credit Limit
      const ALB = result[1]; // Available Loan Balance

      console.log('Personal Credit Limit:', PCL, 'Available Loan Balance:', ALB);

      if (PCL > 0) {
        if (ALB > 0) {
          // this.creditCheckMessage = `Credit check passed (Available loan limit: ${toSmallNum(ALB)} TCash)`;
        } else {
          // this.creditCheckMessage = 'Maximum loan limit reached';
        }
      } else {
        // this.creditCheckMessage = 'No credit limit available';
      }
      console.log('ALB', ALB);
      // Synchronize maximum loan amount
      this.maximum = ALB;
      // this.maximumStr = toSmallNum(ALB).toFixed(2);
      // console.log('this.maximumStr', this.maximumStr);
      // Calculate UNIT amount corresponding to maximum loan limit
      if (this.TCashLoan && ALB > 0) {
        try {
          const maxUnitRequired = await this.TCashLoan.methods["calculateUnitRequirement"](
            ALB
          ).call({
            from: this.account
          });
          this.maxUnitAmount = maxUnitRequired;
          console.log('UNIT amount for maximum loan limit:', toSmallNum(this.maxUnitAmount));
        } catch (e) {
          console.error('Failed to calculate maximum UNIT amount:', e);
        }
      }

      // Calculate minimum UNIT amount corresponding to minimum loan limit (0.000000001 TCash)
      await this.calculateMinUnitAmount();
    },

    async calculateMinUnitAmount() {
      try {
        if (this.TCashLoan && this.account) {
          const minTCashAmount = toBigNum("0.000000001"); // Minimum TCash amount
          const minUnitRequired = await this.TCashLoan.methods["calculateUnitRequirement"](
            minTCashAmount
          ).call({
            from: this.account
          });
          // Convert to small number and format to 9 decimal places
          console.log('calculateMinUnitAmountminUnitRequired', minUnitRequired);
          const minUnitSmall = toSmallNum(minUnitRequired);
          console.log('minUnitSmallAmountminUnitRequired', minUnitSmall);
          this.minUnitAmount = toBigNum(minUnitSmall.toFixed(9));
          console.log('Minimum UNIT amount for 0.000000001 TCash:', minUnitSmall.toFixed(9));
        }
      } catch (e) {
        console.error('Failed to calculate minimum UNIT amount:', e);
        this.minUnitAmount = 0;
      }
    },

    exchangeInputUnit(readonly) {
      console.log('exchangeInputUnitreadonly', readonly);
      console.log('exchangeInputUnit', this.exchangeNumUnit);

      // Handle empty or undefined input
      if (!this.exchangeNumUnit || this.exchangeNumUnit === '') {
        this.exchangeNumUSTN = undefined;
        return true;
      }

      // Check if it's a valid number
      if (!isIntNum(+this.exchangeNumUnit)) {
        this.$message.warning(`Please enter a number`);
        this.exchangeNumUnit = undefined;
        return false;
      }

      // Check decimal places limit (maximum 9 decimal places)
      const inputStr = this.exchangeNumUnit.toString();
      const decimalIndex = inputStr.indexOf('.');
      if (decimalIndex !== -1 && inputStr.length - decimalIndex - 1 > 9) {
        this.$message.warning("Maximum 9 decimal places allowed");
        this.exchangeNumUnit = parseFloat(this.exchangeNumUnit).toFixed(9).replace(/\.?0+$/, '');
        return false;
      }

      // Convert to BigNumber for precise comparison
      const inputBigNum = toBigItem(this.exchangeNumUnit);
      const minValue = toBigItem("0.000000001");

      // Handle case when input value is 0
      if (inputBigNum.isEqualTo(0)) {
        this.exchangeNumUSTN = 0;
        return true;
      }

      // Check if value is positive
      if (inputBigNum.isLessThanOrEqualTo(0)) {
        this.$message.warning("Please enter a value greater than 0.000000001");
        this.exchangeNumUnit = undefined;
        return false;
      }

      // Check minimum UNIT amount (corresponding to 0.000000001 TCash)
      if (this.minUnitAmount > 0 && inputBigNum.comparedTo(new BigNumber(this.minUnitAmount)) < 0) {
        const minUnitDisplay = toSmallNum(this.minUnitAmount);
        this.$message.warning(`Minimum UNIT amount is ${minUnitDisplay.toFixed(9)} (corresponding to 0.000000001 TCash)`);
        this.exchangeNumUnit = minUnitDisplay.toFixed(9);
        return false;
      }

      // console.log('inputBigNum', inputBigNum.toString());
      // console.log('minValue', minValue.toString());
      // console.log('comparison result', inputBigNum.isLessThan(minValue));

      // Check minimum value using BigNumber for precise comparison
      // if (inputBigNum.isLessThan(minValue)) {
      //   this.$message.warning("Please enter a value greater than or equal to 0.000000001");
      //   this.exchangeNumUnit = "0.000000001";
      //   return false;
      // }
      if (toBigItem(this.exchangeNumUnit).comparedTo(new BigNumber(this.balance)) > 0) {
        this.$message.warning("Insufficient UNIT balance");
        return false;
      }
      // Modified logic: When user input UNIT exceeds maximum limit, automatically adjust to maximum allowed value
      if (this.maxUnitAmount > 0 && toBigItem(this.exchangeNumUnit).comparedTo(new BigNumber(this.maxUnitAmount)) > 0) {
        const maxUnitDisplay = toSmallNum(this.maxUnitAmount).toFixed(2);
        this.$message.info(`Automatically adjusted to maximum available UNIT amount: ${maxUnitDisplay}`);
        this.exchangeNumUnit = maxUnitDisplay;
        // Automatically recalculate corresponding TCash amount
        if (!readonly) {
          this.debounce(() => this.getLoansRate());
        }
        return true;
      }

      if (!readonly) {
        this.debounce(() => this.getLoansRate());
        return false;
      }

      return true;
    },
    exchangeInputUSTN(readonly) {
      console.log('exchangeInputUSTN', this.exchangeNumUSTN);

      // Handle empty or undefined input
      if (!this.exchangeNumUSTN || this.exchangeNumUSTN === '') {
        this.exchangeNumUnit = undefined;
        return true;
      }

      // Check if it's a valid number
      if (!isIntNum(+this.exchangeNumUSTN)) {
        this.$message.warning(`Please enter a number`);
        this.exchangeNumUSTN = undefined;
        return false;
      }

      // Check decimal places limit (maximum 9 decimal places)
      const inputStr = this.exchangeNumUSTN.toString();
      const decimalIndex = inputStr.indexOf('.');
      if (decimalIndex !== -1 && inputStr.length - decimalIndex - 1 > 9) {
        this.$message.warning("Maximum 9 decimal places allowed");
        this.exchangeNumUSTN = parseFloat(this.exchangeNumUSTN).toFixed(9).replace(/\.?0+$/, '');
        // this.debounce(() => this.getUnitsRequired());
        return false;
      }

      // Convert to BigNumber for precise comparison
      const inputBigNum = toBigItem(this.exchangeNumUSTN);
      const minValue = toBigItem("0.000000001");

      // Handle case when input value is 0
      if (inputBigNum.isEqualTo(0)) {
        this.exchangeNumUnit = 0;
        return true;
      }

      // Check if value is positive
      if (inputBigNum.isLessThanOrEqualTo(0)) {
        this.$message.warning("Please enter a value greater than 0.000000001");
        this.exchangeNumUSTN = undefined;
        return false;
      }

      // Check minimum value using BigNumber for precise comparison
      if (inputBigNum.isLessThan(minValue)) {
        this.$message.warning(
          `Lending range : 0.000000001 ~ ${toSmallNum(this.maximum)} TCash`
        );
        this.exchangeNumUSTN = "0.000000001";
        return false;
      }
      // Modified logic: When user input TCash exceeds maximum limit, automatically adjust to maximum allowed value
      if (
        toBigItem(this.exchangeNumUSTN).comparedTo(new BigNumber(this.maximum)) > 0
      ) {
        const maxTCashDisplay = toSmallNum(this.maximum).toFixed(2);
        this.$message.info(`Automatically adjusted to maximum borrowable TCash amount: ${maxTCashDisplay}`);
        this.exchangeNumUSTN = maxTCashDisplay;
        // Automatically recalculate corresponding UNIT amount
        if (!readonly) {
          this.debounce(() => this.getUnitsRequired());
        }
        return true;
      }
      if (!readonly) {
        this.debounce(() => this.getUnitsRequired());
      }
      return true;
    },
    count(type = "unit") {
      if (type == "unit") {
        this.exchangeNumUSTN = fixed(
          (this.exchangeNumUnit * this.unitPrice) /
          this.pledgeRate /
          this.TCASHPrice
        );
      } else {
        this.exchangeNumUnit = fixed(
          (this.exchangeNumUSTN * this.TCASHPrice * (this.pledgeRate / 100)) /
          this.unitPrice
        );
      }
    },
    async submit(btn) {
      try {
        if (!this.exchangeInputUnit("readonly")) {
          btn.closeLoad();
          return;
        }
        if (!this.exchangeInputUSTN("readonly")) {
          btn.closeLoad();
          return;
        }
        await this.getPersonalCreditAndAvailable();

        // Since values exceeding limits are automatically adjusted during input, this validation can be simplified
        // Retain validation as a safety measure
        if (toBigItem(this.exchangeNumUSTN).comparedTo(new BigNumber(this.maximum)) > 0) {
          const maxTCashDisplay = toSmallNum(this.maximum).toFixed(2);
          this.$message.info(`Automatically adjusted to maximum borrowable limit ${maxTCashDisplay} TCash`);
          this.exchangeNumUSTN = maxTCashDisplay;
          // Recalculate corresponding UNIT value
          await this.getUnitsRequired();
        }

        // Build transaction parameters
        const txParams = {
          from: this.account,
          value: toBigItem(this.exchangeNumUnit),
          gas: await this.estimateGas(),
          gasPrice: await this.web3.eth.getGasPrice()
        };

        // Send transaction
        let res = await this.TCashLoan.methods.createLoan().send(txParams)
        console.log('res', res);
        btn.closeLoad();
        this.init();
        this.refresh();
        this.$message.success("You have successfully lent TCash!");
      } catch (error) {
        console.error('Loan transaction failed:', error);
        this.$message.error(error.message || 'Loan transaction failed');
        btn.closeLoad();
      }
    },

    // Estimate gas
    async estimateGas() {
      try {
        const estimated = await this.TCashLoan.methods.createLoan()
          .estimateGas({
            from: this.account,
            value: toBigItem(this.exchangeNumUnit)
          });

        // Use multiplier to add some extra gas to prevent insufficient gas
        return Math.floor(estimated * this.GAS_MULTIPLIER);
      } catch (error) {
        console.error('Gas estimation failed:', error);
        // If estimation fails, use default value
        return this.$store.getters.gas;
      }
    },
    refresh() {
      this.$emit("refresh")
    },
    async walletConnected(account) {
      console.log('Wallet connected:', account);
      await this.init();
      await this.getInfo();
      // this.checkCreditEligibility();
    }
  },
  created() {
    // 只在 account 有值的时候执行 init
    if (this.account) {
      this.walletConnected();
    }
  },
  mounted() { },
  watch: {
    account(newVal) {
      if (newVal) {
        this.walletConnected();
        // this.checkCreditEligibility();
      } else {
        this.maximum = 0;
        // this.maximumStr = '0.00';
      }
    }
  }
};
</script>
<style scoped lang="scss">
.exchange-card {
  padding: 0.2rem 0 0.8rem 0;
  border-radius: 0.24rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
  border: 0.01rem solid #272D38;
  min-width: 7.26rem;

  .exchange-tab-box {
    border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
    padding: 0.28rem 0.4rem 0.4rem 0.4rem;
    font-size: 0.32rem;
    font-family: HurmeGeometricSans2-Bold;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.38rem;
    text-align: center;

    img {
      margin: -0.05rem 0.1rem 0 0;
    }
  }

  .exchange-tab-body {
    padding: 0.38rem 0.4rem 0 0.4rem;
    display: flex;
    flex-direction: column;
    // gap: 0.15rem;
  }

  /deep/ .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        font-size: 0.24rem;
        color: #929dad;
        padding: 0.28rem 0.65rem;
        height: auto;
        width: 50%;
        text-align: center;

        &.is-active {
          color: #1f1f1f;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;

          i {
            color: #31c1d0;
          }
        }
      }
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }

  .exchange-item {
    background: rgba(255, 255, 255, 0.05);

    padding: .24rem .2rem;
    min-width: 5.6rem;
    margin-bottom: 0.16rem;
    border: 0.01rem solid rgba(255, 255, 255, 0.25);
    border-radius: 0.08rem;

    position: relative;

    .unit-icon {
      background: rgba(255, 255, 255, 0.1);
      border: 0.01rem solid rgba(255, 255, 255, 0.2);
      border-radius: 0.08rem;
    }
  }

  .exchange-jiantou {
    width: 0.56rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.28rem;
    margin-top: -0.2rem;
    cursor: pointer;
    z-index: 1;
  }

  .exchange-input {
    /deep/ .el-input__inner {
      border: none;
      text-align: right;
      background: transparent !important;
      font-size: 0.34rem;
      font-family: PlusJakartaDisplay, PlusJakartaDisplay;
      font-weight: bold;
      font-style: normal;
      color: #ffffff;
      padding: 0 0;
    }
  }

  .word-sm {
    font-size: 0.16rem;
    // font-weight: 400;
    color: #929DAD;
    line-height: 0.2rem;
    margin-top: 0.15rem;
  }

  .word-big-num {
    font-size: 0.36rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #1f1f1f;
    line-height: 0.42rem;
  }

  .word-sm-black {
    font-size: 0.2rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.24rem;
    // margin-top: 0.15rem;
  }

  .word-sm-num {
    color: #929DAD;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }

  .common-btn-blue {
    margin-top: 0.2rem;
  }

  .iconfont {
    font-size: 0.22rem !important;
    margin-right: 0.03rem;
  }
}

.credit-check-pending {
  color: #929DAD;
  font-size: 0.16rem;
}

.credit-check-passed {
  color: #38F4BA;
  font-size: 0.16rem;
}

.text-success {
  color: #67C23A !important;
}

.text-warning {
  color: #E6A23C !important;
}

.range-text {
  font-size: 0.18rem;
  font-weight: 400;
  color: #e88888;
  line-height: 0.21rem;
  text-align: right;
}

.spaceBetween {
  margin-bottom: .13rem;
}

.credit-check-failed {
  color: #E88888;
  font-size: 0.16rem;
}
</style>
